import { cloneSchema } from './clone';
export function applySchemaTransforms(originalSchema, transforms) {
    return transforms.reduce(function (schema, transform) {
        return transform.transformSchema != null ? transform.transformSchema(cloneSchema(schema)) : schema;
    }, originalSchema);
}
export function applyRequestTransforms(originalRequest, transforms) {
    return transforms.reduce(function (request, transform) {
        return transform.transformRequest != null ? transform.transformRequest(request) : request;
    }, originalRequest);
}
export function applyResultTransforms(originalResult, transforms) {
    return transforms.reduceRight(function (result, transform) {
        return transform.transformResult != null ? transform.transformResult(result) : result;
    }, originalResult);
}
//# sourceMappingURL=transforms.js.map